<div class="link-controller-container">
	<div class="header">
		<button class="back-button" (click)="back()" [title]="'common.back' | translate">
			<img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
		</button>
		<h2>{{ 'link.title' | translate }}</h2>
	</div>

	<div class="link-form">
		<div class="form-group">
			<label for="mac">{{ 'link.mac' | translate }}</label>
			<input id="mac" type="text" [(ngModel)]="mac" [placeholder]="'link.mac_placeholder' | translate" />
		</div>

		<div class="form-actions">
			<button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>
			<button class="save-button" (click)="link()">{{ 'link.submit' | translate }}</button>
		</div>
	</div>
</div>
